import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import styles from "./ViewRolePage.module.scss";
import { AxiosResponse, AxiosErrorType } from "../../../src/types";

interface OrgRoleType {
  id: number;
  name: string;
  permissions: Record<string, boolean>;
}

const ViewOrgRolePage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [orgRoleType, setOrgRoleType] = useState<OrgRoleType | null>(null);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.post<AxiosResponse<{ roles: OrgRoleType[] }>>("/core/role/orgroletype/get", {});
        const roleTypeData = response.data.roles?.find((rt) => rt.id === parseInt(id || "0"));
        if (!roleTypeData) {
          throw new Error("Organization role type not found");
        }
        setOrgRoleType(roleTypeData);
      } catch (err: any) {
        setError(err.response?.data?.message || "Failed to fetch organization role type");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error || !orgRoleType) {
    return <div className={styles.error}>{error || "Role type not found"}</div>;
  }

  return (
    <div className={styles.container}>
      <h2>View Organization Role Type</h2>
      <div className={styles.formGroup}>
        <label>Role Type Name</label>
        <p>{orgRoleType.name}</p>
      </div>
      <div className={styles.formGroup}>
        <label>Permissions</label>
        <p>{JSON.stringify(orgRoleType.permissions)}</p>
      </div>
      <button onClick={() => navigate("/roles")}>Back to Roles</button>
    </div>
  );
};

export default ViewOrgRolePage;
